import { render, staticRenderFns } from "./ProductCommentShow.vue?vue&type=template&id=83e6ea10&"
import script from "./ProductCommentShow.vue?vue&type=script&lang=js&"
export * from "./ProductCommentShow.vue?vue&type=script&lang=js&"
import style0 from "./ProductCommentShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports